import ModelService from '../../base/ModelService';

class User extends ModelService {
  constructor() {
    super('admin/users');
  }
}

export default new User();